<ng-container *ngIf="cartStateService.canBeVisible()">
    <ng-container *ngIf="!cartStateService.isCartEmpty()">
        <p-scrollPanel [style]="{'overflow-y': 'scroll', 'max-height': 'calc(100vh - 150px)'}">
            <ng-container>
                <div class="flex flex-column" *ngIf="cartModel().todaysCharges?.items.length">
                    <div
                        class="mb-2 flex justify-content-center align-items-center py-2 border-round-lg sara-header-bg">
                        <span class="text-white font-bold">Today's charges</span>
                    </div>
                    <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2">
                        <ng-container *ngFor="let pi of cartModel().todaysCharges?.items; let i = index">
                            <div class="p-2 pb-0">
                                <div class="mb-1 flex justify-content-between font-bold">
                                    <span>{{pi.name}}</span>
                                    <span>{{pi.amount| currency}}</span>
                                </div>
                            </div>
                            <div class="flex pb-2 pl-3" *ngIf="pi?.disclosure">
                                <span class="text-primary-700">{{pi.disclosure}}</span>
                                <!-- {{pi.Disclosure}} -->
                            </div>
                            <div class="flex flex-column pb-2 pl-3" *ngIf="pi?.CartDisclosureList?.length > 0">
                                <div class="mb-1 flex justify-content-between text-sm font-bold"
                                    *ngFor="let disclosure of pi.CartDisclosureList">
                                    <span>{{disclosure.Label}}</span>
                                    <span>{{disclosure.Fee | currency}}</span>
                                </div>
                            </div>
                        </ng-container>

                        <div class="p-2" style="border-top: 1px solid;">
                            <div class="mb-1 flex justify-content-between font-bold" *ngClass="cartModel().todaysCharges?.totalTaxAmount">
                                <span>Tax </span>
                                <span>{{cartModel().todaysCharges?.totalTaxAmount| currency}} </span>
                            </div>
                            <div class="mb-1 flex justify-content-between font-bold">
                                <span>Today's Total** </span>
                                <span>{{cartModel().todaysCharges?.totalAmount| currency}} </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex flex-column " *ngIf="cartModel().firstBillCharges?.items.length">
                    <div
                        class="mb-2 flex justify-content-center align-items-center py-2 border-round-lg sara-header-bg">
                        <span class="text-white font-bold">First Bill Charges</span>
                    </div>
                    <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2">
                        <ng-container *ngFor="let pi of cartModel().firstBillCharges?.items; let i = index">
                            <div class="p-2 pb-0">
                                <div class="mb-1 flex justify-content-between font-bold">
                                    <span>{{pi.name}}</span>
                                    <span>{{pi.amount | currency}}</span>
                                </div>
                            </div>
                            <div class="flex pb-2 pl-3 text-sm" *ngIf="pi?.disclosure">
                                <span class="text-primary-700">{{pi.disclosure}}</span>
                                <!-- {{pi.Disclosure}} -->
                            </div>
                        </ng-container>

                        <div class="p-2" style="border-top: 1px solid;">
                            <div class="mb-1 flex justify-content-between font-bold"
                                *ngIf="isCharter">
                                <span>One-Time Tax</span>
                                <span>{{cartModel().firstBillCharges?.totalTaxAmount ?? '0' | currency}}</span>
                            </div>
                            <div class="flex justify-content-between font-bold">
                                <span>Total* </span>
                                <span>{{cartModel().firstBillCharges?.totalAmount | currency}}</span>
                            </div>
                        </div>
                        <div class="p-2 pt-0">
                            <div class="mb-2">
                                <span>* Plus monthly </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex flex-column  mt-2">
                    <div
                        class="mb-2 flex justify-content-center align-items-center py-2 border-round-lg sara-header-bg">
                        <span class="text-white text-base font-semibold">Monthly Charges</span>
                    </div>
                </div>

                <div class="flex flex-column " *ngIf="cartModel().internetCharges">

                    <div class="justify-content-center align-items-center mt-3 dashed">
                        <div class="flex align-items-center justify-content-center mb-4">
                            <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
                            <span class="text-sm font-bold text-primary px-3">Internet</span>
                            <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
                        </div>
                    </div>
                    <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2 p-3 border-round-xl text-sm font-semibold gap-3 flex flex-column"
                        style="background-color: #F0F0F0;">

                        <div class="p-2 pb-0">
                            <div class="mb-2 flex justify-content-between font-bold">
                                <span>{{cartModel().internetCharges?.name}}</span>
                                <span>{{cartModel().internetCharges?.price | currency}} </span>
                            </div>
                        </div>

                        <ng-container *ngFor="let category of cartModel().internetCharges?.monthly?.items">
                            <div>
                                <div class="p-2 pb-0">
                                    <div class="mb-2 flex justify-content-between font-bold">
                                        <span>{{category?.name}}</span>
                                        <span>{{category?.amount | currency}}</span>
                                    </div>
                                </div>
                                <div class="flex pb-2 pl-3" *ngIf="category?.disclosure">
                                    <span class="text-primary-700">{{category?.disclosure}}</span>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="cartModel().internetCharges?.monthly?.promotions?.items?.length > 0">
                            <div class="w-full align-self-center p-4 border-round-lg bg-white">
                                <div class="flex flex-column gap-2 text-sm font-semibold">
                                    <div class="flex flex-column">
                                        <span class="font-bold">Promotions</span>
                                    </div>
                                    <ng-container
                                        *ngFor="let promotion of cartModel().internetCharges?.monthly.promotions?.items">
                                        <div class="flex justify-content-between">
                                            <span>{{ promotion.name }}</span>
                                            <span class="positive-base">{{ promotion.amount| currency }}</span>
                                        </div>
                                        <div class="font-light font-product" *ngIf="promotion.disclosure">
                                            <span [innerHTML]="promotion.disclosure"></span>
                                        </div>
                                    </ng-container>
                                    <p-divider class="flex justify-content-center w-full"></p-divider>
                                    <div class="flex justify-content-between positive-base">
                                        <span>Total Savings</span>
                                        <span>{{ cartModel().internetCharges?.monthly?.promotions?.totalAmount |
                                            currency
                                            }}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <div class="p-2" style="border-top: 1px solid;">
                            <div class="mb-2 flex justify-content-between font-bold"
                                *ngIf="isCharter">
                                <span>Monthly Tax</span>
                                <span>{{cartModel().internetCharges?.monthly?.totalTaxAmount ?? '0' | currency}}</span>
                            </div>
                            <div class="mb-2 flex justify-content-between font-bold">
                                <span>Total </span>
                                <span>{{cartModel().internetCharges?.monthly?.totalAmount | currency}} </span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>


            <div *ngIf="cartModel().wirelessCharges?.monthly?.length">
                <div class="flex flex-column gap-2">
                    <div class="justify-content-center align-items-center mt-3 dashed">
                        <div class="flex align-items-center justify-content-center mb-4">
                            <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
                            <span class="text-sm font-bold text-primary px-3">Wireless</span>
                            <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
                        </div>
                    </div>
                    <ng-container *ngFor="let lineData of cartModel().wirelessCharges?.monthly; let index = index">
                        <div *ngIf="lineData.lineNumber > 0" style="background-color: #F0F0F0;"
                            class="p-3 border-round-xl text-sm font-semibold gap-3 flex flex-column">
                            <div class="align-items-center flex gap-2 justify-content-center text-base font-semibold">
                                <span>Line {{ lineData.lineNumber }}</span>
                                <span *ngIf="lineData.lineNumber === 1"> (Primary)</span>
                            </div>
                            <!-- Device Name -->
                            <div class="mb-2 flex justify-content-center font-bold">
                                <span>{{ lineData.device?.name }}
                                    <ng-container *ngIf="lineData.device?.amount > 0">({{ lineData.device?.amount|
                                        currency }})</ng-container></span>
                            </div>
                            <ng-container *ngFor="let chargeItem of lineData.charges?.items">
                                <div>
                                    <div class="p-2 pb-0">
                                        <div class="mb-2 flex justify-content-between font-bold">
                                            <span>{{chargeItem?.name}}</span>
                                            <span>{{chargeItem?.amount | currency}}</span>
                                        </div>
                                    </div>
                                    <div class="flex pb-2 pl-3" *ngIf="chargeItem?.disclosure">
                                        <span class="text-primary-700">{{chargeItem?.disclosure}}</span>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="lineData.promotions?.items?.length > 0">
                                <div class="w-full align-self-center p-4 border-round-lg bg-white">
                                    <div class="flex flex-column gap-2 text-sm font-semibold">
                                        <div class="flex flex-column">
                                            <span class="font-bold">Promotions</span>
                                        </div>
                                        <ng-container *ngFor="let promotion of lineData.promotions?.items">
                                            <div class="flex justify-content-between">
                                                <span>{{ promotion.name }}</span>
                                                <span class="positive-base">{{ promotion.amount| currency }}</span>
                                            </div>
                                            <div class="font-light font-product" *ngIf="promotion.disclosure">
                                                <span [innerHTML]="promotion.disclosure"></span>
                                            </div>
                                        </ng-container>
                                        <!-- Trade-In -->
                                        <ng-container *ngIf="lineData.tradeIn">
                                            <div class="w-full align-self-center border-round-lg border-1 p-2 border-black-alpha-20">
                                                <div class="flex flex-column gap-2 text-sm font-semibold">
                                                    <div class="flex justify-content-between">
                                                        <span class="font-bold">Trade-In</span>
                                                        <span>{{ lineData.tradeIn.model }}</span>
                                                    </div>
                                                    <div class="flex justify-content-between">
                                                        <span>Trade-In Value</span>
                                                        <span class="positive-base">{{ lineData.tradeIn.tradeInValue | currency }}</span>
                                                    </div>
                                                    <div class="flex justify-content-between" *ngIf="lineData.tradeIn.promoDiscount">
                                                        <span>Promo Discount</span>
                                                        <span class="positive-base">{{ lineData.tradeIn.promoDiscount | currency }}</span>
                                                    </div>
                                                    <div class="font-light font-product">
                                                        <span>{{ lineData.tradeIn.monthlyCredit | currency }} credit for 
                                                            {{ lineData.tradeIn.financingMonths }} months (Applied within 2-3 Billing Cycles)</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <p-divider class="flex justify-content-center w-full"></p-divider>
                                        <div class="flex justify-content-between positive-base">
                                            <span>Total Savings</span>
                                            <span>{{ ((lineData.promotions?.totalAmount || 0) - (lineData.tradeIn?.monthlyCredit || 0)) | currency }}</span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <p-divider class="flex justify-content-center w-full no-margin-divider"></p-divider>

                            <!-- Line Total -->
                            <div class="flex justify-content-between">
                                <span>Total</span>
                                <span>{{ lineData?.totalAmount| currency }}</span>
                            </div>
                        </div>
                    </ng-container>

                </div>
                <!-- <app-wireless-cart (wirelessCartUpdated)="onWirelessCartUpdated($event)"></app-wireless-cart> -->
            </div>

            <div class="flex flex-column " *ngIf="cartModel().videoCharges">

                <div class="justify-content-center align-items-center mt-3 dashed">
                    <div class="flex align-items-center justify-content-center mb-4">
                        <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
                        <span class="text-sm font-bold text-primary px-3">Video</span>
                        <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
                    </div>
                </div>
                <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2 p-3 border-round-xl text-sm font-semibold gap-3 flex flex-column"
                    style="background-color: #F0F0F0;">

                    <div class="p-2 pb-0">
                        <div class="mb-2 flex justify-content-between font-bold">
                            <span [innerHTML]="cartModel().videoCharges?.name"></span>
                            <span>{{cartModel().videoCharges?.price | currency}} </span>
                        </div>
                    </div>

                    <ng-container *ngFor="let category of cartModel().videoCharges?.monthly?.items">
                        <div>
                            <div class="p-2 pb-0">
                                <div class="mb-2 flex justify-content-between font-bold">
                                    <span [innerHTML]="category?.name"></span>
                                    @if (category?.showIncludedLabel) {
                                        <span>Included</span>
                                    } @else {
                                        <span>{{category?.amount | currency}}</span>
                                    }
                                </div>
                            </div>
                            <div class="flex pb-2 pl-3" *ngIf="category?.disclosure">
                                <span class="text-primary-700" [innerHTML]="category?.disclosure"></span>
                            </div>
                            <div class="flex flex-column pb-2 pl-3" *ngIf="category?.CartDisclosureList?.length > 0">
                                <div class="mb-1 flex justify-content-between text-sm font-bold"
                                    *ngFor="let disclosure of category.CartDisclosureList">
                                    <span>{{disclosure.Label}}</span>
                                    <span>{{disclosure.Fee | currency}}</span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="cartModel().videoCharges?.monthly?.promotions?.items?.length > 0">
                        <div class="w-full align-self-center p-4 border-round-lg bg-white">
                            <div class="flex flex-column gap-2 text-sm font-semibold">
                                <div class="flex flex-column">
                                    <span class="font-bold">Promotions</span>
                                </div>
                                <ng-container
                                    *ngFor="let promotion of cartModel().videoCharges?.monthly.promotions?.items">
                                    <div class="flex justify-content-between">
                                        <span [innerHTML]="promotion.name"></span>
                                        <span class="positive-base">{{ promotion.amount| currency }}</span>
                                    </div>
                                    <div class="font-light font-product" *ngIf="promotion.disclosure">
                                        <span [innerHTML]="promotion.disclosure"></span>
                                    </div>
                                </ng-container>
                                <p-divider class="flex justify-content-center w-full"></p-divider>
                                <div class="flex justify-content-between positive-base">
                                    <span>Total Savings</span>
                                    <span>{{ cartModel().videoCharges?.monthly?.promotions?.totalAmount |
                                        currency
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <div class="p-2" style="border-top: 1px solid;">
                        <div class="mb-2 flex justify-content-between font-bold"
                            *ngIf="cartModel().videoCharges?.monthly?.totalTaxAmount">
                            <span>Tax</span>
                            <span>{{cartModel().videoCharges?.monthly?.totalTaxAmount | currency}} </span>
                        </div>
                        <div class="mb-2 flex justify-content-between font-bold">
                            <span>Total </span>
                            <span>{{cartModel().videoCharges?.monthly?.totalAmount | currency}} </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex flex-column " *ngIf="cartModel().voiceCharges">

                <div class="justify-content-center align-items-center mt-3 dashed">
                    <div class="flex align-items-center justify-content-center mb-4">
                        <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
                        <span class="text-sm font-bold text-primary px-3">Voice</span>
                        <div class="border-top-1 surface-800 flex-1 bg-black-alpha-40"></div>
                    </div>
                </div>
                <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2 p-3 border-round-xl text-sm font-semibold gap-3 flex flex-column"
                    style="background-color: #F0F0F0;">

                    <div class="p-2 pb-0">
                        <div class="mb-2 flex justify-content-between font-bold">
                            <span [innerHTML]="cartModel().voiceCharges?.name"></span>
                            <span>{{cartModel().voiceCharges?.price | currency}} </span>
                        </div>
                    </div>

                    <ng-container *ngFor="let category of cartModel().voiceCharges?.monthly?.items">
                        <div>
                            <div class="p-2 pb-0">
                                <div class="mb-2 flex justify-content-between font-bold">
                                    <span [innerHTML]="category?.name"></span>
                                    @if (category?.showIncludedLabel) {
                                        <span>Included</span>
                                    } @else {
                                        <span>{{category?.amount | currency}}</span>
                                    }
                                </div>
                            </div>
                            <div class="flex pb-2 pl-3" *ngIf="category?.disclosure">
                                <span class="text-primary-700" [innerHTML]="category?.disclosure"></span>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="cartModel().voiceCharges?.monthly?.promotions?.items?.length > 0">
                        <div class="w-full align-self-center p-4 border-round-lg bg-white">
                            <div class="flex flex-column gap-2 text-sm font-semibold">
                                <div class="flex flex-column">
                                    <span class="font-bold">Promotions</span>
                                </div>
                                <ng-container
                                    *ngFor="let promotion of cartModel().voiceCharges?.monthly.promotions?.items">
                                    <div class="flex justify-content-between">
                                        <span [innerHTML]="promotion.name"></span>
                                        <span class="positive-base">{{ promotion.amount| currency }}</span>
                                    </div>
                                    <div class="font-light font-product" *ngIf="promotion.disclosure">
                                        <span [innerHTML]="promotion.disclosure"></span>
                                    </div>
                                </ng-container>
                                <p-divider class="flex justify-content-center w-full"></p-divider>
                                <div class="flex justify-content-between positive-base">
                                    <span>Total Savings</span>
                                    <span>{{ cartModel().voiceCharges?.monthly?.promotions?.totalAmount | currency
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <div class="p-2" style="border-top: 1px solid;">
                        <div class="mb-2 flex justify-content-between font-bold"
                            *ngIf="cartModel().voiceCharges?.monthly?.totalTaxAmount">
                            <span>Tax</span>
                            <span>{{cartModel().voiceCharges?.monthly?.totalTaxAmount | currency}} </span>
                        </div>
                        <div class="mb-2 flex justify-content-between font-bold">
                            <span>Total: </span>
                            <span>{{cartModel().voiceCharges?.monthly?.totalAmount | currency}} </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="flex flex-column " *ngIf="videoPackageSelected() && currentFlow() === 'Video'">
            <div class="mb-3 flex justify-content-center align-items-center mt-2 dashed">
                <span class="font-product font-bold">Video</span>
            </div>
            <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2">

                <div class="p-2 pb-0">
                    <div class="mb-2 flex justify-content-between font-bold">
                        <span>{{videoPackageSelected()?.ComponentName}}</span>
                        <span>{{videoPackageSelected()?.Price | currency}} </span>
                    </div>
                </div>

                <ng-container *ngFor="let category of videoCategory()">
                    <div class="p-2 pb-0">
                        <div class="mb-2 flex justify-content-between font-bold">
                            <span>{{category?.Name}}</span>
                            @if (category?.Fee?.Fee > 0 || category?.Fee?.Fee < 0) { <span>{{category?.Fee.Fee |
                                currency}}</span>
                                } @else {
                                <span>Included</span>
                                }
                        </div>
                    </div>
                    <div class="flex pb-2 pl-3" *ngIf="category?.CartDisclosure">
                        <span class="text-primary-700">{{category?.CartDisclosure}}</span>
                    </div>
                </ng-container>

                <div class="p-2" style="border-top: 1px solid;">
                    <div class="mb-2 flex justify-content-between font-bold">
                        <span>Video Total </span>
                        <span>{{videoChargesTotal() | currency}} </span>
                    </div>
                </div>
            </div>
        </div> -->

            <div class="flex flex-column " *ngIf="cartModel().packagesCharges?.items.length">
                <div class="mb-3 flex justify-content-center align-items-center mt-2 dashed">
                    <span class="font-product font-bold">Package Discounts & Fees</span>
                </div>
                <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2">
                    <ng-container *ngFor="let category of cartModel().packagesCharges?.items">
                        <div class="p-2 pb-0">
                            <div class="mb-2 flex justify-content-between font-bold">
                                <span>{{category?.name}}</span>
                                <span>{{category?.amount | currency}}</span>
                            </div>
                        </div>
                        <div class="flex pb-2 pl-3" *ngIf="category?.disclosure">
                            <span class="text-primary-700">{{category?.disclosure}}</span>
                        </div>
                    </ng-container>

                    <div class="p-2" style="border-top: 1px solid;">
                        <div class="mb-2 flex justify-content-between font-bold">
                            <span>Total </span>
                            <span>{{cartModel().packagesCharges?.totalAmount| currency}} </span>
                        </div>
                    </div>
                </div>
            </div>


            @if (cartModel().savingAndPromotionCharges?.items.length) {
            <div class="flex flex-column ">
                <div class="mb-3 flex justify-content-center align-items-center mt-2 dashed">
                    <span class="font-product font-bold">Savings & Promotions</span>
                </div>
                <div class="border-1 border-round-xl border-black-alpha-20 bg-gray p-2 pb-0 mb-2">
                    <ng-container *ngFor="let reward of cartModel().savingAndPromotionCharges?.items">
                        <div class="p-2">
                            <div class="mb-1 flex justify-content-between font-bold">
                                <span>{{reward?.name}}</span>
                                <span>{{reward?.amount | currency}}</span>
                            </div>
                        </div>
                        <div class="flex pl-3 pb-2" *ngIf="reward?.disclosure">
                            <span class="text-primary-700" [innerHTML]="reward?.disclosure"></span>
                        </div>
                    </ng-container>
                </div>
            </div>
            }
            <div class="flex flex-column  mt-2">
                <div class="mb-2 flex justify-content-center align-items-center py-2 border-round-lg sara-header-bg">
                    <span class="text-white text-base font-semibold">Total Monthly Charges</span>
                </div>
                <div style="background-color: #F0F0F0;" class="flex flex-column p-3 border-round-xl">
                    <div *ngIf="cartModel().internetCharges?.monthly">
                        <div class="mb-2 flex justify-content-between font-semibold text-sm">
                            <span>Internet Total*: </span>
                            <span>{{cartModel().internetCharges.monthly.totalAmount| currency}} </span>
                        </div>
                        <!-- <span class="text-sm font-light">
                        ** Plus taxes and fees. Price higher after discount(s) removed or promo(s)
                        end.
                    </span> -->
                        <p-divider class="flex justify-content-center w-full"></p-divider>
                    </div>
                    <div *ngIf="cartModel().voiceCharges?.monthly">
                        <div class="mb-2 flex justify-content-between font-semibold text-sm">
                            <span>Voice Total*: </span>
                            <span>{{cartModel().voiceCharges.monthly.totalAmount | currency}}</span>
                        </div>
                        <p-divider class="flex justify-content-center w-full"></p-divider>
                    </div>
                    <div *ngIf="cartModel().wirelessCharges?.totalMonthlyAmount">
                        <div class="mb-2 flex justify-content-between font-semibold text-sm">
                            <span>Wireless Total*: </span>
                            <span>{{cartModel().wirelessCharges?.totalMonthlyAmount | currency}}</span>
                        </div>
                        <!-- <span class="text-sm font-light">
                        ** Plus taxes and fees. Price higher after discount(s) removed or promo(s)
                        end.
                    </span> -->
                        <p-divider class="flex justify-content-center w-full"></p-divider>
                    </div>
                    <!-- <div *ngIf="videoChargesTotal() && currentFlow() === 'Video'">
                    <div class="mb-2 flex justify-content-between font-semibold text-sm">
                        <span>Video Total*: </span>
                        <span>{{videoChargesTotal() ?? 0 | currency}}</span>
                    </div>
                    <span class="text-sm font-light">
                        ** Plus taxes and fees. Price higher after discount(s) removed or promo(s)
                        end.
                    </span>
                    <p-divider class="flex justify-content-center w-full"></p-divider>
                </div> -->
                    <div>
                        <div class="mb-2 flex justify-content-between font-semibold text-sm">
                            <span>Monthly Total*: </span>
                            <span>{{cartModel().monthlyTotal | currency}}</span>
                        </div>
                        <span class="text-sm font-light">
                            ** Plus taxes and fees. Price higher after discount(s) removed or promo(s)
                            end.
                        </span>
                    </div>
                </div>
            </div>
        </p-scrollPanel>
    </ng-container>
    <ng-container *ngIf="cartStateService.isCartEmpty()">
        <div class="flex align-items-center px-6 py-3 xl:border-1 border-black-alpha-40 border-round-xl">
            <i class="pi pi-bundle-empty-cart mr-2"></i>
            <span>Your Cart is <b>Empty</b></span>
        </div>
    </ng-container>
</ng-container>
